<template>
  <v-chip
    small
    label
    :color="labelColor"
    text-color="white"
    class="mr-2"
  >
    {{ labelText }}
  </v-chip>
</template>

<script>
export default {
  props: ["invoiceAmount", "paymentsAmount"],
  computed: {
    percentageOfPayment() {
      return Math.round((this.paymentsAmount / this.invoiceAmount) * 100);
    },
    labelColor() {
      if (this.percentageOfPayment >= 100) {
        return "green";
      } else if (this.paymentsAmount <= 0) {
        return "red";
      } else {
        return "orange";
      }
    },
    labelText() {
      if (this.percentageOfPayment >= 100) {
        return "Оплачений";
      } else if (this.paymentsAmount <= 0) {
        return "Неоплачений";
      } else {
        return "Частково оплачений";
      }
    },
  },
};
</script>